import type { CompanyLeadPayload } from 'packages/signup/components/signupForm/types';

export default function removePIIFromCompanyLeadPayload(companyLead: CompanyLeadPayload) {
  return {
    number_employees: companyLead.number_employees,
    submitted_from: companyLead.submitted_from,
    sold_by: companyLead.sold_by,
    sold_by_accountant_id: companyLead.sold_by_accountant_id,
    campaign: companyLead.campaign,
    tier: companyLead.tier,
    hi_interest: companyLead.hi_interest,
  };
}
